module.exports = __webpack_public_path__ + "kg.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/kg.svg
// module id = 889
// module chunks = 0